export type UiSortOrder = "asc" | "desc";

const compareValues = (a: unknown, b: unknown, order: UiSortOrder): number => {
  const dir = order === "asc" ? 1 : -1;
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  if (typeof a === "number" && typeof b === "number") return (a - b) * dir;
  if (typeof a === "boolean" && typeof b === "boolean") {
    return (Number(a) - Number(b)) * dir;
  }
  const da = a instanceof Date ? a.getTime() : Date.parse(String(a));
  const db = b instanceof Date ? b.getTime() : Date.parse(String(b));
  if (!Number.isNaN(da) && !Number.isNaN(db)) return (da - db) * dir;
  return String(a).localeCompare(String(b), undefined, { sensitivity: "base" }) * dir;
};

export function sortRows<T>(
  rows: T[],
  sortBy: string,
  sortOrder: UiSortOrder,
  accessor: (row: T, field: string) => unknown
): T[] {
  return [...rows].sort((a, b) =>
    compareValues(accessor(a, sortBy), accessor(b, sortBy), sortOrder)
  );
}
